define([
        'text!edge/platform/widgets/loading/templates/loading-template.html'],
    (templateStr)=> {
        /**
         * Usage example:
         *
         * Inline:
         *<div gw-pl-loading-msg
         *  inline
         *  error-inline="getError()"
         *></div>
         */

        return ['$rootScope', 'CallTrackerService', ($rootScope, CallTrackerService)=> {
            return {
                restrict: 'A',
                scope: {
                    id: '@id',
                    callGroup: '@',
                    msg: '@',
                    errorMsg: '@',
                    errorInline: '='
                },
                template: templateStr,

                link: (scope, element, attrs)=> {
                    scope.inline = attrs.inline !== undefined;
                    scope.display = false;
                    scope.error = false;
                    scope.initTime = new Date();
                    scope.position = {
                        top: attrs.top,
                        left: attrs.left,
                        right: attrs.right,
                        bottom: attrs.bottom
                    };

                    $rootScope.$watch('callTrackerCounter', ()=> {
                        scope.error = CallTrackerService.anyErrorAfter(scope.initTime, scope.callGroup);
                        //bug, which prevents subsequent LoadingIndications: scope.display = !scope.error && CallTrackerService.anyInFlightCall(scope.callGroup);
                        scope.display = CallTrackerService.anyInFlightCall(scope.callGroup);
                    });
                }
            };
        }];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/loading/LoadingIndicationDirective.js